/**
 * PartnerFaq – Häufige Fragen für Partner.
 * Separat ausgelagert, damit PartnerOverview unter 300 Zeilen bleibt.
 */
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const ITEMS = [
  {
    q: "Wann bekomme ich meine Provision ausgezahlt?",
    a: "Sobald die Provision auf „Auszahlbar\" steht (in der Regel nach Ablauf der Widerrufsfrist), wird sie zur nächsten Auszahlung freigegeben. Du findest alle Details unter „Auszahlungen\".",
  },
  {
    q: "Was passiert, wenn jemand sein Abo wieder kündigt?",
    a: "Bereits ausgezahlte Provisionen bleiben dir. Künftige monatliche Provisionen entfallen, sobald das Abo endet. Bei einer Rückerstattung wird die zugehörige Provision storniert.",
  },
  {
    q: "Darf ich den Code auf Instagram oder im Newsletter teilen?",
    a: "Ja, sehr gerne! Du darfst den Code und deinen Link in deinen Kanälen teilen. Bitte keine bezahlten Google-/Meta-Ads auf den Markennamen „MusiKonzept\" schalten.",
  },
  {
    q: "Bekomme ich auch Provision auf Webinare und Einzelkurse?",
    a: "Ja. 20% Provision gibt es auf jeden Verkauf, der über deinen Link oder mit deinem Code zustande kommt – Mitgliedschaften, Ausbildungen, Webinare und Einzelkurse.",
  },
];

const PartnerFaq = () => (
  <Card>
    <CardHeader>
      <CardTitle>Häufige Fragen</CardTitle>
    </CardHeader>
    <CardContent>
      <Accordion type="single" collapsible>
        {ITEMS.map((item, i) => (
          <AccordionItem key={i} value={`q${i}`}>
            <AccordionTrigger>{item.q}</AccordionTrigger>
            <AccordionContent>{item.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </CardContent>
  </Card>
);

export default PartnerFaq;
